'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { CheckIcon, XIcon, AlertTriangleIcon, InfoIcon, LoaderCircleIcon } from 'lucide-react';

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = 'system' } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps['theme']}
			className="toaster group"
			icons={{
				success: <CheckIcon className="bg-primary/15 text-primary size-5 rounded-sm stroke-[2.5] p-1" />,
				error: <XIcon className="bg-destructive/15 text-destructive size-5 rounded-sm stroke-[2.5] p-1" />,
				warning: (
					<AlertTriangleIcon className="size-5 rounded-sm bg-amber-500/15 p-1 text-amber-600 dark:text-amber-400" />
				),
				info: <InfoIcon className="size-5 rounded-sm bg-blue-500/15 p-1 text-blue-600 dark:text-blue-400" />,
				loading: <LoaderCircleIcon className="text-muted-foreground size-5 animate-spin rounded-sm stroke-[2.5] p-1" />,
			}}
			toastOptions={{
				classNames: {
					toast: 'cn-toast',
				},
			}}
			{...props}
		/>
	);
};

export { Toaster };
